import { Directive, ElementRef, HostListener, Input } from '@angular/core';

import { PhxTooltipDirective } from './phx-tooltip.directive';

export type PhxTooltipTruncateDirection = 'horizontal' | 'vertical' | 'either';

@Directive({
  selector: '[phx-tooltip-on-truncate]',
})
export class PhxTooltipOnTruncateDirective {
  /** Which direction should be checked for truncation. */
  @Input() public phxTooltipTruncateDirection: PhxTooltipTruncateDirection = 'horizontal';
  /** Whether the truncation tooltip is disabled. */
  @Input() public phxTruncationTooltipDisabled: boolean = false;
  private el: HTMLElement;

  constructor(
    elRef: ElementRef,
    private phxTooltip: PhxTooltipDirective,
  ) {
    this.el = elRef.nativeElement;
  }

  @HostListener('mouseenter', ['$event'])
  public onMouseenter(event: MouseEvent): void {
    if (this.phxTruncationTooltipDisabled) return;
    event.stopImmediatePropagation();
    if (this.isEllipsisActive()) this.phxTooltip.showTooltip();
  }

  @HostListener('mouseleave')
  public onMouseleave(): void {
    this.phxTooltip.hideTooltip();
  }

  private isEllipsisActive(): boolean {
    const horizontalOverflow: boolean = ['horizontal', 'either'].includes(this.phxTooltipTruncateDirection) &&
      this.el.offsetWidth < this.el.scrollWidth;
    const verticalOverflow: boolean = ['vertical', 'either'].includes(this.phxTooltipTruncateDirection) &&
      this.el.offsetHeight < this.el.scrollHeight;
    return horizontalOverflow || verticalOverflow;
  }
}